/**
 * Profile API wrapper (#762).
 *
 * PUT /api/profile updates displayName / timezone / preferences with optimistic
 * locking — the caller must pass the current `version` and gets the updated
 * user row (with the incremented version) back.
 */

import { apiGlobal } from './api';

/**
 * @param {{displayName?:string, timezone?:string, preferences?:Object, version:number}} body
 * @returns {Promise<{user: Object}>}
 */
export const updateProfile = (body) => apiGlobal.put('/profile', body);
